
import React from 'react';
import { Mail } from 'lucide-react';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { UseFormReturn } from 'react-hook-form';
import { cn } from "@/lib/utils";

interface EmailFieldProps {
  form: UseFormReturn<any>;
  placeholder?: string;
}

export const EmailField: React.FC<EmailFieldProps> = ({ 
  form, 
  placeholder = "you@example.com" 
}) => {
  return (
    <FormField
      control={form.control}
      name="email"
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-foreground/90">Email</FormLabel>
          <FormControl>
            <div className="relative">
              <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
                <Mail className="h-4 w-4 text-muted-foreground/70" />
              </div>
              <Input 
                className={cn(
                  "pl-9 h-10 bg-background/50",
                  "border-input/50 focus-visible:border-purple-500",
                  "focus-visible:ring-2 focus-visible:ring-purple-500/30",
                  "transition-all duration-200"
                )}
                type="email"
                placeholder={placeholder}
                {...field}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
